import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-dark-card relative overflow-hidden" data-id="element-242">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-243"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-245">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 text-gold mb-5" data-id="element-246">
            <span className="text-2xl" data-id="element-247">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4" data-id="element-248">
            El sistema más completo de industrialización de alimentos para el
            aula técnica de América Latina
          </h2>
          <h3 className="text-xl font-bold text-gold-gradient mb-3" data-id="element-249">
            Mega Pack Industrialización de Alimentos en el Aula
          </h3>
          <p className="text-base md:text-lg text-gray-300 mb-10" data-id="element-250">
            5 tomos · 4 bonos estratégicos · Todo listo para usar desde hoy.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-251">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-black p-6 rounded-2xl border border-dark-border" data-id="element-252">
            <div className="flex items-start gap-3" data-id="element-253">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-254" />
              <p className="text-gray-400 text-sm" data-id="element-255">
                No es teoría copiada de un manual europeo sin contexto regional.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-256">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-257" />
              <p className="text-gray-400 text-sm" data-id="element-258">
                No es una colección de recetas sueltas sin fundamento técnico.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-259">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-260" />
              <p className="text-gray-400 text-sm" data-id="element-261">
                No es material que tengas que adaptar entero para que funcione
                en tu país.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gold/10 p-6 rounded-2xl border border-gold/30 relative overflow-hidden" data-id="element-262">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 blur-3xl rounded-full" data-id="element-263"></div>
            <div className="flex items-start gap-3 relative z-10" data-id="element-264">
              <Check className="text-gold shrink-0 mt-1" size={20} data-id="element-265" />
              <p className="text-white font-medium text-base leading-relaxed" data-id="element-266">
                Es un sistema para que entres al taller con confianza y dictes
                clases que de verdad enseñen a procesar, conservar y transformar
                alimentos de forma segura, técnica y rentable.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}